<template>
	<div class="container">
		<div v-if="news.list == false" style="heght: 70vh">
			<div class="iv2-news__items-null row clearfix">
				<div class="column full">
					<div style="padding: 2rem 0;">
						<h4 class="size-24" style="text-align: center;">表示する記事はありません。</h4>
						<p style="text-align: center;">現在、投稿されている記事はありません。</p>
					</div>
					<div class="row clearfix">
						<div class="column full" style="margin: 0 auto;">
							<div style="text-align: center;">
								<span>
									<router-link
										to
										class="theme__main-btn is-btn is-btn-ghost2 is-upper size-18"
										style="border: 0; border-radius: 50px; letter-spacing: 2px; max-width: 100%; width: 334px; padding-top: 15px; padding-bottom: 15px;"
									>トップページに戻る</router-link>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="iv2-news-archive pl-2 pr-2">
				<div class="row">
					<div class="iv2-news-category d-none d-xl-inline-block col-xl-9">
						<label
							v-for="category in news.categories"
							:key="category.id"
							:for="'sort_' + category.id"
							@click="change(category.id)"
							:class="{ active: isActive === category.id }"
							class="iv2-news-category__button theme-b__news-category"
						>
							<input
								type="radio"
								:value="category.id"
								:id="'sort_' + category.id"
								v-model="filterCategory"
								name="category"
								class="iv2-news-category__button-input"
								autocomplete="off"
							/>
							{{ category.name }}
						</label>
					</div>
					<div
						class="iv2-news-category__mobile col-12 d-flex d-xl-none align-items-center justify-content-center"
					>
						<select class="iv2-news-category__select w-100 m-3" name="archive" v-model="filterCategory">
							<option
								v-for="category in news.categories"
								:key="category.id"
								:value="category.id"
							>{{ category.name }}</option>
						</select>
					</div>
					<div class="iv2-news-season col-xl-3 d-flex align-items-center justify-content-center">
						<select
							class="iv2-news-season__select m-1 d-none d-xl-block"
							name="archive"
							v-model="filterArchive"
						>
							<option
								v-for="archive in archives"
								:key="archive.year"
								:value="archive.year"
							>{{ archive.name }}</option>
						</select>
					</div>
				</div>
			</div>
			<div class="row clearfix">
				<div class="column full">
					<div class="spacer height-60"></div>
				</div>
			</div>
			<div class="row clearfix">
				<div v-for="item in eventAction" :key="item.id" class="iv2-news-item my-4 col-12">
					<router-link :to="'/news/' + item.id" class="iv2-news-item__link">
						<div class="row">
							<div class="iv2-news-item__img fit-img col-md-4 col-12">
								<img :src="item.thumbnail" class="m-0" :alt="'「' + item.title + '」' + alt_text" />
							</div>

							<div class="iv2-news-item__list col-md-8 col-12 px-md-5">
								<div class="d-flex">
									<p class="iv2-news-item__date">
										{{
										item.created | moment
										}}
									</p>
									<p class="iv2-news-item__label size-14">{{ item.category_name }}</p>
									<p
										v-if="
                                            isAfter(
                                                setDatetime(item.created),
                                                end
                                            )
                                        "
										class="iv2-news-item__new ml-1 size-14"
									>{{ new_label }}</p>
								</div>
								<h3 class="iv2-news-item__title">{{ item.title }}</h3>
								<p class="iv2-news-item__summary">{{ item.body + '...' }}</p>
							</div>
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";
export default {
	props: ["news"],
	data() {
		return {
			new_label: "NEW",
			alt_text: "のサムネイル",

			archives: [
				{ year: 9999, name: "年別アーカイブ" },
				{ year: 2020, name: "2020年" },
				{ year: 2019, name: "2019年" },
			],
			filterCategory: 999,
			isActive: 999,
			filterArchive: 9999,
			start: "",
			end: moment().format(),
		};
	},
	computed: {
		eventAction: function () {
			let list = this.news.list.slice();
			if (this.filterCategory !== 999) {
				list = list.filter((element) => {
					return element.category_id === this.filterCategory;
				});
			} else if (this.filterArchive !== 9999) {
				list = list.filter((element) => {
					return element.created.startsWith(this.filterArchive);
				});
			} else if (
				this.filterCategory !== 999 &&
				this.filterArchive !== 9999
			) {
				list = list.filter((element) => {
					return (
						element.category_id === this.filterCategory &&
						element.created.startsWith(this.filterArchive)
					);
				});
			}
			return list;
		},
	},
	methods: {
		change: function (num) {
			this.isActive = num;
		},

		isAfter: function (start, end) {
			return moment(start).isAfter(end);
		},

		setDatetime: function (start) {
			return moment(start).add(14, "days").format();
		},
	},
	watch: {
		$route: function (to, from) {
			if (to.path !== from.path) {
				this.radioSelect = false;
			}
		},
	},
	filters: {
		moment: function (created) {
			return moment(created).format("YYYY.MM.DD");
		},
	},
};
</script>

<style lang="scss">
.iv2-news__items-null {
	padding: 8rem 0;
}

.iv2-news-item {
	.iv2-news-item__link {
		display: block;
		text-decoration: none;

		&:hover .iv2-news-item__img {
			opacity: 0.7;
		}

		.iv2-news-item__img {
			height: 250px;
			-webkit-transition: 0.3s;
			transition: 0.3s;
		}

		.iv2-news-item__date {
			font-size: 24px;
			line-height: 1;
			margin-right: 20px;
			padding-top: 3px;
		}

		.iv2-news-item__label {
			text-align: center;
			border: 1px solid;
			border-radius: 30px;
			line-height: 1;
			padding: 6px 40px;
			margin-right: 10px;
			background-color: #fff;
		}

		.iv2-news-item__new {
			color: #ff5c5c;
			border: 1px solid;
			border-radius: 30px;
			padding: 6px 10px;
			line-height: 1;
			background-color: #fff;
		}

		.iv2-news-item__title {
			font-size: 1.3rem;
			text-decoration: underline;
			margin-top: 30px;
		}
	}
}

/* PC */
@media (min-width: 1200px) {
	.iv2-news-archive {
		.iv2-news-season__select {
			-webkit-appearance: none;
			-moz-appearance: none;
			appearance: none;
			padding-left: 10px;
			border-radius: 0;
			border: 1px solid #000000;
			width: 180px;
			background-color: #ffffff;
			z-index: 1;

			&::-ms-expand {
				display: none;
			}
		}

		.iv2-news-season:before {
			content: "";
			top: 50%;
			right: 70px;
			display: block;
			position: absolute;
			z-index: 3;
			width: 7px;
			height: 7px;
			border-top: 2px solid #000;
			border-right: 2px solid #000;
			-webkit-transform: translateY(-50%) rotate(135deg);
			transform: translateY(-50%) rotate(135deg);
		}
		.iv2-news-category__button {
			display: inline-block;
			background-color: transparent;
			border: none;
			margin: 0;
			padding: 7px 15px 0;
			border-bottom: 3px solid transparent;
			-webkit-transition: 0.2s;
			transition: 0.2s;
			cursor: pointer;
			position: relative;

			.iv2-news-category__button-input {
				display: none;
				:checked {
					.iv2-news-category__button {
						border-bottom: 3px solid;
					}
				}
			}
			.iv2-news-category__button-name {
				margin: auto;
			}
		}
	}

	.iv2-news-item__list {
		padding: 0 100px;
	}
}
/* TABLET or SP */
@media (max-width: 1199px) {
	.iv2-news-archive {
		padding: 10px;
		background-color: transparent !important;

		.iv2-news-category__select {
			-webkit-appearance: none;
			-moz-appearance: none;
			appearance: none;
			border-radius: 0;
			border: 1px solid #000;
			padding: 0 10px;
			background-color: #fff;
		}

		.iv2-news-category__mobile:before {
			content: "";
			right: 45px;
			display: block;
			position: absolute;
			z-index: 5;
			width: 7px;
			height: 7px;
			border-top: 2px solid #000;
			border-right: 2px solid #000;
			-webkit-transform: rotate(135deg);
			transform: rotate(135deg);
		}
	}
}
/* TABLET Only */
@media (min-width: 768px) and (max-width: 1199px) {
	.iv2-news__items-null {
		padding: 15rem 0;
	}
}
/* SP Only */
@media (max-width: 767px) {
	.iv2-news-item {
		.iv2-news-item__link {
			.iv2-news-item__date {
				font-size: 16px;
				padding-top: 8px;
			}

			.iv2-news-item__title {
				margin-top: 10px;
			}
		}
	}
}
</style>
